import { useCallback } from 'react';
import {
  useGetRouteStationsPricesByStationCode,
  getStationServicePriceByPriceType
} from 'entities/stations';

import { Station } from 'dataSources/Typicode/stations';

export const useSortStations = () => {
  const getRouteStationsPricesByStationCode = useGetRouteStationsPricesByStationCode();

  const getStationServicePriceinEUR = useCallback((
    station: Station,
    serviceCodes: number[],
    priceType: string,
  ) => {
    const stationServices = getRouteStationsPricesByStationCode(station.code)?.services || [];
    const stationServicePrices = stationServices.find(({ service }) => service.code.toString() === serviceCodes[0].toString());
    return getStationServicePriceByPriceType(priceType, stationServicePrices).amount;
  }, [getRouteStationsPricesByStationCode]);

  const sortStations = useCallback((
    stations: Station[],
    serviceCodes: number[],
    priceType: string,
    sortType: 'ASC' | 'DESC' = 'ASC'
  ) => {
    const { stationWithPrice, stationWithoutPrice} = stations.reduce((acc, station) => {
      if (getStationServicePriceinEUR(station, serviceCodes, priceType)) {
        acc.stationWithPrice.push(station)
      } else {
        acc.stationWithoutPrice.push(station)
      }
      return acc;
    }, { stationWithoutPrice: [], stationWithPrice: [] } as {
      stationWithoutPrice: Station[];
      stationWithPrice: Station[];
    });
    stationWithPrice
        .sort((firstStation, secondStation) => {
          const firstStationServicePriceInEUR = getStationServicePriceinEUR(firstStation, serviceCodes, priceType);
          const secondStationServicePriceInEUR = getStationServicePriceinEUR(secondStation, serviceCodes, priceType);
          if(sortType === 'ASC') {
            return Number(firstStationServicePriceInEUR || null) > Number(secondStationServicePriceInEUR || null) ? 1 : -1;
          } else {
            return Number(secondStationServicePriceInEUR || null) > Number(firstStationServicePriceInEUR || null) ? 1 : -1;
          }
          
        })
    return [...stationWithPrice, ...stationWithoutPrice]
  }, [
    getStationServicePriceinEUR
  ]);

  return sortStations;
};
